import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import IntroPage from './IntroPage';
import HomePage from './HomePage';
import ConseilsPage from './ConseilsPage';
import AboutPage from './AboutPage';
import LegalPage from './LegalPage';
import NurseNuitPage from './NurseNuitPage';
import NurseJourPage from './NurseJourPage';
import AccompagnementPage from './AccompagnementPage';

function App() {
  const [hasVisited, setHasVisited] = useState(false);

  useEffect(() => {
    // Vérifie si c'est la première visite
    const visited = localStorage.getItem('hasVisitedBefore');
    if (visited) {
      setHasVisited(true);
    } else {
      // Marque comme visité pour les prochaines fois
      localStorage.setItem('hasVisitedBefore', 'true');
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/" 
          element={hasVisited ? <HomePage /> : <IntroPage />} 
        />
        <Route path="/home" element={<HomePage />} />
        <Route path="/ConseilsPage" element={<ConseilsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/nurse-nuit" element={<NurseNuitPage />} />
        <Route path="/nurse-jour" element={<NurseJourPage />} />
        <Route path="/accompagnement-parental" element={<AccompagnementPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;